export default __webpack_public_path__ + "static/media/course_sections-icon-2.1cac3fce.svg";